module.exports = __webpack_public_path__ + "assets/img/enquiry2.e28c6ec9.png";